// NATIVE
import * as React from 'react';

// INSTALLED
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// CUSTOM
import { SnackAlert } from '../../SnackAlert';
import { timeToClosedToast } from '../../../commons';
import MultipleSnackbars from '../../MultipleSnackbars';
import { closeSessionGlobal } from '../../../commons/utils';
import { storeEditParameter } from '../../../store/parameters';
import { EditParameter } from '../../parametros/editar/EditParameter';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import validationSchema from '../../parametros/formModels/editar/validationSchema';
import formInitialValues from '../../parametros/formModels/editar/formInitialValues';
import editParameterFormModel from '../../parametros/formModels/editar/editParameterFormModel';
import { DetailParameter } from '../../parametros/detalle/DetailParameter';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const DetailDialogParameter = (props: any) => {
  const { open, handleCloseModalDetalleParameter, buttons = false } = props;

  const dispatch = useDispatch();

  const { formId, formField } = editParameterFormModel;

  const currentValidationSchema = validationSchema[0];

  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [data, setMsgErrors] = React.useState([]);
  const [alert_snack, setAlertSnack] = React.useState(false);

  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]);

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [btnText, setBtnText] = React.useState('Editar Parametro');

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  const handleClose = () => {
    handleCloseModalDetalleParameter(false);
  };

  return (
    <React.Fragment>
      <ModalSessionExpired open={modalSessionExpired} />
      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />

      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Detalle Parametros
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={() => console.log()}
            >
              <>
                <Form id={formId}>
                  <DetailParameter formField={formField} />
                </Form>
              </>
            </Formik>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
